import { Button, Drawer } from 'antd';
import styled from 'styled-components';
import logoSmall from 'assets/logos/logoSmall.svg';
import Icon from '@ant-design/icons';

export const MobileMenu = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 280px !important;
  }

  .ant-drawer-header {
    height: 48px;
    padding: 8px 16px;
  }

  .ant-drawer-body {
    padding: 8px 0 0 16px;
  }

  .ant-divider {
    margin: 16px 0;
    border-color: #d9d9d9;
  }

  .anticon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;

    svg {
      width: 15px;
      height: 15px;
      color: #000;

      path {
        color: black;
        fill: black;
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    flex: 1;
  }
`;

export const CloseButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  background-color: #fff;
  cursor: pointer;

  svg {
    color: #000;
  }
`;

export const Logo = styled(Icon)`
  display: block;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  color: transparent;
  text-decoration: none;
  max-width: 32px;
  height: 26px;
  background-image: url(${logoSmall});
`;

export const Text = styled.span<{ $small?: boolean; $gray?: boolean }>`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: ${({ small }) => (small ? '0.875rem' : '1rem')};
  color: ${({ gray }) => (gray ? '#8c8c8c' : '#000')};
  text-align: start;
  white-space: break-spaces;
`;

export const UserName = styled(Text)`
  font-weight: bold;
  font-size: 1rem;
  line-height: 100%;
  letter-spacing: 0%;
`;

export const MenuItem = styled.button.attrs({ type: 'button' })`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  background: transparent;
  border: 0;
  cursor: pointer;
`;

export const WelcomeMessage = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const Logout = styled(Icon)`
  margin-left: auto;
  margin-right: 16px;
`;

export const LogoutButton = styled(Button)`
  background: #f5222d;
  width: 248px;
  border-radius: 2px;
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;

  &.ant-btn:focus,
  &.ant-btn:hover,
  &.ant-btn:not(.not-active):active {
    background: #f5222d;
    color: white;
  }

  .anticon svg path {
    fill: white;
  }
`;
